import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCronLogs } from '../redux/slices/cronSlice';
import Navbar from '../components/Navbar';
import Spinner from '../components/Spinner';
import { useNavigate } from 'react-router-dom';

const CronLogs = () => {
  const dispatch = useDispatch();
  const { cronLogs = [], loading, error } = useSelector((state) => state.cron);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const logsPerPage = 10;
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchCronLogs());
  }, [dispatch]);

  const filteredLogs = cronLogs.filter((log) =>
    log.description.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const indexOfLastLog = currentPage * logsPerPage;
  const indexOfFirstLog = indexOfLastLog - logsPerPage;
  const currentLogs = filteredLogs.slice(indexOfFirstLog, indexOfLastLog);
  const totalPages = Math.ceil(filteredLogs.length / logsPerPage);

  const formatDateTime = (timestamp) => {
    if (!timestamp) return '-';
    const date = new Date(timestamp);
    return date.toISOString().replace('T', ' ').slice(0, 19); 
  };

  return (
    <>
      <Navbar
        title="Cron Logs"
        subtitle="Track and analyze cron job performance"
        buttonLabel="Back To Dashboard"
        buttonAction={() => navigate('/')}
      />
      <div className="container mx-auto p-4">
        <h2 className="text-2xl font-semibold mb-4">Cron Job Logs</h2>

        <input
          type="text"
          placeholder="Search by description..."
          className="border p-2 w-48 mb-4 mt-10 rounded-lg"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />

        {loading && (
          <div className="flex justify-center items-center h-32">
            <Spinner />
          </div>
        )}

        {error && <div className="text-red-500 text-center mt-4">{error}</div>}

        {!loading && !error && (
          <div className="overflow-x-auto">
            <table className="w-full border-collapse border border-gray-300 shadow-lg text-sm">
              <thead>
                <tr className="bg-gray-200 text-left text-xs">
                  <th className="border p-2">ID</th>
                  <th className="border p-2">Description</th>
                  <th className="border p-2 text-center">Status</th>
                  <th className="border p-2 text-center">Execution Time</th>
                </tr>
              </thead>
              <tbody>
                {currentLogs.length > 0 ? (
                  currentLogs.map((log) => (
                    <tr key={log.id} className="border hover:bg-gray-100 transition">
                      <td className="border p-2 text-center">{log.id}</td>
                      <td className="border p-2">{log.description}</td>
                      <td className="border p-2 text-center">{log.status}</td>
                      <td className="border p-2 text-center">{formatDateTime(log.execution_time)}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center p-4">
                      No logs available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}

        {!loading && totalPages > 1 && (
          <div className="flex justify-center mt-4 space-x-2 items-center">
            <button
              className={`px-3 py-1 border rounded ${
                currentPage === 1 ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-200'
              }`}
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(1)}
            >
              {'<<'}
            </button>
            <button
              className={`px-3 py-1 border rounded ${
                currentPage === 1 ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-200'
              }`}
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(currentPage - 1)}
            >
              {'<'}
            </button>
            <span className="px-3 py-1 border rounded bg-gray-200">{currentPage}</span>
            <button
              className={`px-3 py-1 border rounded ${
                currentPage === totalPages ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-200'
              }`}
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(currentPage + 1)}
            >
              {'>'}
            </button>
            <button
              className={`px-3 py-1 border rounded ${
                currentPage === totalPages ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-200'
              }`}
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(totalPages)}
            >
              {'>>'}
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default CronLogs;
